<template>
  <nav class="panel">
    <p class="panel-tabs is-size-7x">
        <a @click="$router.push('/account/profile')" :class="{ 'is-active': isActive('/account/profile') }">
            <span class="icon is-small"><i class="fa fa-user"></i></span>
            <span>Me</span>
        </a>
        <template v-if="hasHousehold">
          <a @click="$router.push('/account/household')" :class="{ 'is-active': isActive('/account/household') }">
              <span class="icon is-small"><i class="fa fa-home"></i></span>
              <span>{{ $t("Household") }}</span>
          </a>
          <a @click="$router.push('/account/people')" :class="{ 'is-active': isActive('/account/people') }">
              <span class="icon is-small"><i class="fa fa-users"></i></span>
              <span>{{ $t("People") }}</span>
          </a>
          <a @click="$router.push('/account/tags')" :class="{ 'is-active': isActive('/account/tags') }">
              <span class="icon is-small"><i class="fa fa-tags"></i></span>
              <span>{{ $t("Tags") }}</span>
          </a>
          <a @click="$router.push('/account/meter')" :class="{ 'is-active': isActive('/account/meter') }">
              <span class="icon is-small"><i class="fa fa-tachometer"></i></span>
              <span>Meter</span>
          </a>
        </template>
    </p>
  </nav>
</template>

<script>
export default {
  name: "AccountTabs"
};
</script>